import { View, Dialog, Button } from "../base";
import { RegionSettingsForm, RegionSettingsFormData } from "./RegionSettingsForm";

type RegionSettingsDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  config: RegionSettingsFormData;
  onChange: (key: string) => (value: unknown) => void;
};

export const RegionSettingsDialog = ({ isOpen, onClose, config, onChange }: RegionSettingsDialogProps) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Region Settings"
      size="flex"
      className="w-full max-w-[600px] min-w-0 max-h-[90vh] mx-4"
    >
      <View className="p-4 sm:p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
        <RegionSettingsForm
          config={config}
          onChange={onChange}
        />
      </View>
      <View className="flex items-center justify-end p-4 gap-4 border-t border-gray-200 dark:border-gray-700">
        <Button
          variant="neutral"
          size="sm"
          outline
          onClick={onClose}
        >
          Close
        </Button>
      </View>
    </Dialog>
  );
};
